'use client'

import { useMemo } from 'react'
import { isEmpty } from 'lodash'

import { useLocation } from '@marketplace-web/shared/browser'
import { CatalogNavigationModel, SelectedFilter } from '@marketplace-web/domain/catalog-data'

import { useCatalogContext } from '../CatalogProvider'
import useGetSelectedCatalogs from './useGetSelectedCatalogs'

interface UseSelectedFiltersResult {
  selectedCatalogs: Array<CatalogNavigationModel>
  selectedStaticFilters: Array<SelectedFilter>
}

const useGetSelectedStaticFilters = (): UseSelectedFiltersResult => {
  const {
    state: { filters },
  } = useCatalogContext()
  const selectedCatalogs = useGetSelectedCatalogs()
  const queryParams = useLocation().searchParams

  const selectedStaticFilters: Array<SelectedFilter> = useMemo(() => {
    const selectedFilterList: Array<SelectedFilter> = []
    const { priceFrom, priceTo } = filters
    const query = queryParams.search_text

    selectedCatalogs.forEach(catalog => {
      selectedFilterList.push({
        name: 'catalogIds',
        label: catalog.title,
        value: catalog.id,
      })
    })

    if (!isEmpty(query)) {
      selectedFilterList.push({
        name: 'query',
        label: String(query),
        value: String(query),
      })
    }

    if (!isEmpty(priceFrom)) {
      selectedFilterList.push({
        name: 'priceFrom',
        value: String(priceFrom),
      })
    }

    if (!isEmpty(priceTo)) {
      selectedFilterList.push({
        name: 'priceTo',
        value: String(priceTo),
      })
    }

    return selectedFilterList
  }, [filters, selectedCatalogs, queryParams.search_text])

  return { selectedCatalogs, selectedStaticFilters }
}

export default useGetSelectedStaticFilters
